function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export class AbstractTracker {
    get eventName() {
        return this.name;
    }
    get eventData() {
        return this.data;
    }
    drop() {
        this.data = Object.create(null);
    }
    constructor(name){
        _define_property(this, "name", void 0);
        _define_property(this, "data", void 0);
        this.name = name;
        this.data = Object.create(null);
        this.name = name;
        this.track = this.track.bind(this);
    }
}

//# sourceMappingURL=AbstractTracker.js.map